import { z } from "zod"
import { PoapCodeSchema, type PoapCodeType } from "@tutellus/schemas"

export const PoapCodeValidation = z.object({
  code: z.string({ required_error: "code is required" }),
  limit: z.number({ required_error: "limit is required" }),
})

export class PoapCode {
  constructor(
    private readonly _code: string,
    private readonly _limit: number,
  ) {}

  static create({ code, limit }: z.infer<typeof PoapCodeValidation>) {
    const { error, success } = PoapCodeValidation.safeParse({
      code,
      limit,
    })
    if (!success) throw new Error(error.message)
    return new PoapCode(code, limit)
  }

  static createFromAPI(data: PoapCodeType) {
    const { error, success } = PoapCodeSchema.safeParse(data)
    if (!success) throw new Error(`Invalid PoapCode data: ${error.message}`)

    return PoapCode.create({
      code: data.code,
      limit: data.limit,
    })
  }

  get code() { return this._code } // prettier-ignore
  get limit() { return this._limit } // prettier-ignore

  serialize() {
    return {
      code: this.code,
      limit: this.limit,
    }
  }
}

export type PoapCodeSerialized = ReturnType<PoapCode["serialize"]>
